import { render } from "./PopupHeader.vue?vue&type=template&id=5ea7047a&scoped=true"
const script = {}

import "./PopupHeader.vue?vue&type=style&index=0&id=5ea7047a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ea7047a"]])

export default __exports__